const KEY = "memeradar_client_id";
export const AUTH_KEY = "alphaapeing_auth";

function uuid() {
  return "cid-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getAuth() {
  try {
    return JSON.parse(localStorage.getItem(AUTH_KEY) || "null");
  } catch {
    return null;
  }
}

export function getClientId() {
  const a = getAuth();
  if (a?.user?.id) return "u_" + a.user.id;
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(KEY, id);
  }
  return id;
}
